(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    // 使用事件委托，在 document 上监听点击事件
    // 这样即使 DOM 更新，事件监听器仍然有效
    document.addEventListener('click', function(event) {
      // 首先排除 facet-floating-filter 及其内部元素的点击
      const facetFloatingFilter = event.target.closest('facet-floating-filter');
      if (facetFloatingFilter) return;

      // 检查点击的是否是 .yg-sort_by 或其子元素
      const ygSortBy = event.target.closest('.yg-sort_by');
      if (!ygSortBy) return;

      const facetsDrawer = document.getElementById('facets-drawer');
      if (!facetsDrawer || typeof facetsDrawer.show !== 'function') return;

      // 打开抽屉
      facetsDrawer.show().then(function() {
        // 等待抽屉打开后，检查并触发 accordion toggle
        setTimeout(function() {
          const accordion = document.querySelector('#facet-form #accordion-sort-by');
          const toggle = accordion?.querySelector('.accordion__toggle');
          
          if (accordion && toggle) {
            // 如果 accordion 已经打开，就不需要再触发 toggle
            if (accordion.open) {
              return;
            }
            
            // 如果 accordion 还没打开，则打开它并触发 toggle
            accordion.setAttribute('open', '');
            accordion.setAttribute('aria-expanded', 'true');
            // 触发点击事件来确保所有相关事件都被触发
            toggle.click();
          }
        }, 100);
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-blog-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class YGBlogV1 extends HTMLElement {
      connectedCallback() {
        this.formatNumbers();
      }

      formatNumbers() {
        const locale = document.documentElement.lang || navigator.language || 'en-US';
        const formatter = new Intl.NumberFormat(locale);

        this.querySelectorAll('[data-yg-number]').forEach((node) => {
          const value = Number(node.getAttribute('data-yg-number'));

          if (!Number.isNaN(value)) {
            node.textContent = formatter.format(value);
          }
        });
      }
    }

    const boot = () => {
      if (!window.customElements.get('yg-blog-v1')) {
        window.customElements.define('yg-blog-v1', YGBlogV1);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  class YGStack extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.updateScrollState();
      this.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      this.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    handleScroll() {
      window.requestAnimationFrame(() => this.updateScrollState());
    }

    handleResize() {
      window.requestAnimationFrame(() => this.updateScrollState());
    }

    updateScrollState() {
      const canScrollUp = this.scrollTop > 0;
      const canScrollDown = this.scrollTop + this.clientHeight < this.scrollHeight - 1;

      this.classList.toggle('less', canScrollUp);
      this.classList.toggle('more', canScrollDown);
    }
  }

  if (!window.customElements.get('yg-stack')) {
    window.customElements.define('yg-stack', YGStack);
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-overview"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGParameter extends YGUtils {
      constructor() {
        super();
        this._onClick = this._onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this._onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
      }

      _onClick(e) {
        const btn = e.target.closest('.yg-parameter-btn');
        if (!btn || !this.contains(btn)) return;

        const contentMore = this.querySelector('.yg-parameter-content-more');
        const textEl = btn.querySelector('.yg-parameter-button-text');
        const icon = btn.querySelector('svg');
        if (!contentMore || !textEl) return;

        const isActive = contentMore.classList.toggle('active');

        const moreText = textEl.getAttribute('data-more-text') || 'See More';
        const lessText = textEl.getAttribute('data-less-text') || 'See Less';
        textEl.textContent = isActive ? lessText : moreText;

        if (icon) {
          icon.style.transition = 'transform .2s ease-in-out';
          icon.style.transform = isActive ? 'rotate(180deg)' : 'rotate(0deg)';
        }
      }
    }

    if (!window.customElements.get('yg-parameter')) {
      window.customElements.define('yg-parameter', YGParameter);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-tabs-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabHeader = document.querySelector('.yg-product-tab-header');
    if (!tabHeader) return;

    const placeholder = document.createElement('div');
    placeholder.style.display = 'none';
    placeholder.style.width = '100%';
    tabHeader.parentNode.insertBefore(placeholder, tabHeader);

    function getHeaderThreshold() {
      const rootStyle = getComputedStyle(document.documentElement);
      const headerHeight = parseFloat(rootStyle.getPropertyValue('--header-height')) || 0;
      const headerVisible = parseFloat(rootStyle.getPropertyValue('--header-is-visible')) || 1;
      return (headerHeight - 1.5) * headerVisible;
    }

    let originalTop = tabHeader.getBoundingClientRect().top + window.scrollY;

    function refreshOriginalTop() {
      tabHeader.style.position = 'static';
      tabHeader.style.top = null;
      tabHeader.style.left = null;
      tabHeader.style.right = null;
      tabHeader.style.width = null;
      tabHeader.style.zIndex = null;

      originalTop = tabHeader.getBoundingClientRect().top + window.scrollY;
    }

    function updateStickyState() {
      const threshold = getHeaderThreshold();
      const scrollY = window.scrollY;

      if (scrollY >= originalTop - threshold) {
        if (tabHeader.style.position !== 'fixed') {
          placeholder.style.height = `${tabHeader.offsetHeight}px`;
          placeholder.style.display = 'block';
          tabHeader.style.position = 'fixed';
          tabHeader.style.top = `${threshold}px`;
          tabHeader.style.left = '0';
          tabHeader.style.right = '0';
          tabHeader.style.width = '100%';
          tabHeader.style.zIndex = '20';
        }
      } else {
        if (tabHeader.style.position === 'fixed') {
          placeholder.style.display = 'none';
          tabHeader.style.position = 'static';
          tabHeader.style.top = null;
          tabHeader.style.left = null;
          tabHeader.style.right = null;
          tabHeader.style.width = null;
          tabHeader.style.zIndex = null;
        }
      }
    }

    function handleResize() {
      refreshOriginalTop();
      updateStickyState();
    }

    refreshOriginalTop();
    updateStickyState();

    window.addEventListener('scroll', updateStickyState, { passive: true });
    window.addEventListener('resize', handleResize);

    class YGProductTabV2 extends YGUtils {
      constructor() {
        super();

        this.tabs = [];
        this.tabTargets = [];
        this.animationFrame = null;
        this.activationTolerance = 2;

        this.handleTabClick = this.handleTabClick.bind(this);
        this.scheduleActiveTabUpdate = this.scheduleActiveTabUpdate.bind(this);
      }

      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.yg-product-tab-header-tab'));
        this.tabTargets = this.tabs
          .map((tab) => {
            const targetId = tab.getAttribute('href')?.slice(1);
            const target = targetId ? document.getElementById(targetId) : null;

            return target ? { tab, target } : null;
          })
          .filter(Boolean);

        this.addEventListener('click', this.handleTabClick);
        window.addEventListener('scroll', this.scheduleActiveTabUpdate, { passive: true });
        window.addEventListener('resize', this.scheduleActiveTabUpdate);

        this.scheduleActiveTabUpdate();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleTabClick);
        window.removeEventListener('scroll', this.scheduleActiveTabUpdate);
        window.removeEventListener('resize', this.scheduleActiveTabUpdate);

        if (this.animationFrame !== null) {
          window.cancelAnimationFrame(this.animationFrame);
          this.animationFrame = null;
        }
      }

      handleTabClick(event) {
        const tab = event.target.closest('.yg-product-tab-header-tab');
        if (!tab || !this.contains(tab)) return;

        const tabTarget = this.tabTargets.find((item) => item.tab === tab);
        if (!tabTarget) return;

        event.preventDefault();
        const activationLine = this.getActivationLine();
        const targetTop = tabTarget.target.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
          top: Math.max(0, targetTop - activationLine + this.activationTolerance),
          behavior: 'smooth',
        });

        this.scheduleActiveTabUpdate();
      }

      getActivationLine() {
        const rootStyle = getComputedStyle(document.documentElement);
        const headerHeight = parseFloat(rootStyle.getPropertyValue('--header-height')) || 0;

        return headerHeight + this.getBoundingClientRect().height;
      }

      scheduleActiveTabUpdate() {
        if (this.animationFrame !== null) return;

        this.animationFrame = window.requestAnimationFrame(() => {
          this.animationFrame = null;
          this.updateActiveTab();
        });
      }

      updateActiveTab() {
        let activeTab = null;
        const activationLine = this.getActivationLine();

        this.tabTargets.forEach(({ tab, target }) => {
          const targetRect = target.getBoundingClientRect();

          if (
            targetRect.top <= activationLine + this.activationTolerance &&
            targetRect.bottom > activationLine - this.activationTolerance
          ) {
            activeTab = tab;
          }
        });

        this.tabs.forEach((tab) => {
          tab.classList.toggle('active', tab === activeTab);
        });
      }
    }

    if (!window.customElements.get('yg-product-tabs-v2')) {
      window.customElements.define('yg-product-tabs-v2', YGProductTabV2);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabHeader = document.querySelector('.yg-product-tab-header');
    if (!tabHeader) return;

    const placeholder = document.createElement('div');
    placeholder.style.display = 'none';
    placeholder.style.width = '100%';
    tabHeader.parentNode.insertBefore(placeholder, tabHeader);

    function getHeaderThreshold() {
      const rootStyle = getComputedStyle(document.documentElement);
      const headerHeight = parseFloat(rootStyle.getPropertyValue('--header-height')) || 0;
      const headerVisible = parseFloat(rootStyle.getPropertyValue('--header-is-visible')) || 1;
      return (headerHeight - 1.5) * headerVisible;
    }

    let originalTop = tabHeader.getBoundingClientRect().top + window.scrollY;

    function refreshOriginalTop() {
      tabHeader.style.position = 'static';
      tabHeader.style.top = null;
      tabHeader.style.left = null;
      tabHeader.style.right = null;
      tabHeader.style.width = null;
      tabHeader.style.zIndex = null;

      originalTop = tabHeader.getBoundingClientRect().top + window.scrollY;
    }

    function updateStickyState() {
      const threshold = getHeaderThreshold();
      const scrollY = window.scrollY;

      if (scrollY >= originalTop - threshold) {
        if (tabHeader.style.position !== 'fixed') {
          placeholder.style.height = `${tabHeader.offsetHeight}px`;
          placeholder.style.display = 'block';
          tabHeader.style.position = 'fixed';
          tabHeader.style.top = `${threshold}px`;
          tabHeader.style.left = '0';
          tabHeader.style.right = '0';
          tabHeader.style.width = '100%';
          tabHeader.style.zIndex = '20';
        }
      } else {
        if (tabHeader.style.position === 'fixed') {
          placeholder.style.display = 'none';
          tabHeader.style.position = 'static';
          tabHeader.style.top = null;
          tabHeader.style.left = null;
          tabHeader.style.right = null;
          tabHeader.style.width = null;
          tabHeader.style.zIndex = null;
        }
      }
    }

    function handleResize() {
      refreshOriginalTop();
      updateStickyState();
    }

    refreshOriginalTop();
    updateStickyState();

    window.addEventListener('scroll', updateStickyState, { passive: true });
    window.addEventListener('resize', handleResize);

    class YGParameter extends YGUtils {
      constructor() {
        super();
        this._onClick = this._onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this._onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
      }

      _onClick(e) {
        const btn = e.target.closest('.yg-parameter-btn');
        if (!btn || !this.contains(btn)) return;

        const contentMore = this.querySelector('.yg-parameter-content-more');
        const textEl = btn.querySelector('.yg-parameter-button-text');
        const icon = btn.querySelector('svg');
        if (!contentMore || !textEl) return;

        const isActive = contentMore.classList.toggle('active');

        const moreText = textEl.getAttribute('data-more-text') || 'See More';
        const lessText = textEl.getAttribute('data-less-text') || 'See Less';
        textEl.textContent = isActive ? lessText : moreText;

        if (icon) {
          icon.style.transition = 'transform .2s ease-in-out';
          icon.style.transform = isActive ? 'rotate(180deg)' : 'rotate(0deg)';
        }
      }
    }

    if (!window.customElements.get('yg-parameter')) {
      window.customElements.define('yg-parameter', YGParameter);
    }

    class YGProductTabHeader extends YGUtils {
      constructor() {
        super();

        this._onTabClick = this._onTabClick.bind(this);

        // 离开 Tab1 时记录的位置
        this._lastFirstTabScroll = null;

        // 防止重复 scroll
        this._scrolling = false;
      }

      connectedCallback() {
        this.addEventListener('click', this._onTabClick, true);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onTabClick, true);
      }

      _getHeaderThreshold() {
        const rootStyle = getComputedStyle(document.documentElement);

        const headerHeight = parseFloat(rootStyle.getPropertyValue('--header-height')) || 0;

        const headerVisible = parseFloat(rootStyle.getPropertyValue('--header-is-visible')) || 1;

        return (headerHeight - 1.5) * headerVisible;
      }

      _scrollTo(top) {
        if (this._scrolling) return;

        if (Math.abs(window.scrollY - top) < 2) return;

        this._scrolling = true;

        window.scrollTo({
          top,
          behavior: 'auto',
        });

        requestAnimationFrame(() => {
          this._scrolling = false;
        });
      }

      _onTabClick(event) {
        const tab = event.target.closest('.yg-product-tab');

        if (!tab || !this.contains(tab)) return;

        const firstTab = this.querySelector('.yg-product-tab1');

        if (!firstTab) return;

        const previousFirstActive = firstTab.classList.contains('is-active');

        const clickedFirst = tab.classList.contains('yg-product-tab1');

        const threshold = this._getHeaderThreshold();

        // 当前 header 的页面绝对位置（仅当占位符真正位于文档流中时使用它）
        const headerFlowTop =
          typeof placeholder !== 'undefined' && placeholder && placeholder.offsetParent !== null
            ? placeholder.getBoundingClientRect().top + window.scrollY
            : originalTop;

        const destination = Math.max(0, headerFlowTop - threshold);

        /**
         * Tab1 -> 其他 Tab
         */
        if (!clickedFirst) {
          if (previousFirstActive) {
            this._lastFirstTabScroll = window.scrollY;
          }

          requestAnimationFrame(() => {
            this._scrollTo(destination);
          });

          return;
        }

        /**
         * 其他 Tab -> Tab1
         */
        if (!previousFirstActive && this._lastFirstTabScroll !== null) {
          const savedScroll = this._lastFirstTabScroll;

          this._lastFirstTabScroll = null;

          requestAnimationFrame(() => {
            this._scrollTo(savedScroll);
          });
        }
      }
    }

    if (!window.customElements.get('yg-product-tab-header')) {
      window.customElements.define('yg-product-tab-header', YGProductTabHeader);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-timeline"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    class YGTimelineSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiperInstance = null;
        this.timelineItems = [];
        this.timelineLines = [];
        this.timelineLineContainer = null;
      }

      connectedCallback() {
        this.initSwiper();
        this.initTimelineInteraction();
      }

      disconnectedCallback() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      initSwiper() {
        const swiperElement = this.querySelector('.swiper');

        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
        }

        this.swiperInstance = new Swiper(swiperElement, { 
          breakpoints: { 
            100: { 
              spaceBetween: 12, 
              slidesPerView: 1, 
            },
          }, 
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        });

        // 监听Swiper幻灯片变化事件
        this.swiperInstance.on('slideChange', () => {
          this.updateTimelineOpacity(this.swiperInstance.realIndex);
          this.scrollToTimelineItem(this.swiperInstance.realIndex);
        });

      }

      initTimelineInteraction() {
        // 获取所有时间线项和线条
        this.timelineItems = Array.from(this.querySelectorAll('.yg-line-item'));
        this.timelineLines = Array.from(this.querySelectorAll('.yg-line'));
        this.timelineLineContainer = this.querySelector('.yg-timeline-line');
        
        // 为每个时间线项添加点击事件
        this.timelineItems.forEach((item, index) => {
          item.addEventListener('click', () => {
            if (this.swiperInstance) {
              this.swiperInstance.slideTo(index);
              this.updateTimelineOpacity(index);
              this.scrollToTimelineItem(index);
            }
          });
        });
        
        // 初始化时设置正确的透明度
        setTimeout(() => {
          if (this.swiperInstance) {
            this.updateTimelineOpacity(this.swiperInstance.realIndex);
            this.scrollToTimelineItem(this.swiperInstance.realIndex);
          }
        }, 100);
      }

      updateTimelineOpacity(activeIndex) {
        const lastItemIndex = this.timelineItems.length - 1;
        const hasLeadingLine = this.timelineLines.length === this.timelineItems.length + 1 &&
          (this.timelineLines[0].compareDocumentPosition(this.timelineItems[0]) & Node.DOCUMENT_POSITION_FOLLOWING);

        // 重置所有时间线项的状态
        this.timelineItems.forEach((item, index) => {
          item.style.opacity = index <= activeIndex ? '1' : '0.4';
          item.classList.toggle('active', index === activeIndex);
        });
        
        // 处理线条的透明度
        this.timelineLines.forEach((line, index) => {
          const isActiveLine = hasLeadingLine
            ? index <= activeIndex
            : index < activeIndex || (index === activeIndex && activeIndex === lastItemIndex);

          line.style.opacity = isActiveLine ? '1' : '0.4';
        });
      }

      scrollToTimelineItem(index) {
        if (!this.timelineLineContainer || !this.timelineItems[index]) return;
        
        const timelineItem = this.timelineItems[index];
        const container = this.timelineLineContainer;
        
        // 计算需要滚动的位置，使目标元素居中或靠左
        const containerWidth = container.offsetWidth;
        const itemOffsetLeft = timelineItem.offsetLeft;
        const itemWidth = timelineItem.offsetWidth;
        
        // 滚动到使目标元素靠左的位置
        const scrollPosition = itemOffsetLeft - 70; // 留20px的左边距
        
        // 平滑滚动到目标位置
        container.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }

    }

    if (!customElements.get('yg-timeline-swiper')) {
      customElements.define('yg-timeline-swiper', YGTimelineSwiper);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", ()=>{
    class YGVideoList02 extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
          const ygSwiper = this.querySelector('yg-swiper').swiper;
          if (!ygSwiper) return;
          
          // 检测是否是移动端 (根据CSS中的媒体查询 700px 作为断点)
          

          ygSwiper.on('slideChangeTransitionEnd', (e) => {
            this.switchVideoStatus(e)
          });
          
        }

        switchVideoStatus(e){
          // 从 e 对象中获取当前激活块
          const currentSlide = e.slides[e.activeIndex];
          // 若要获取 block id，假设每个 slide 有 data-block-id 属性
          const currentBlockId = currentSlide ? currentSlide.dataset.blockId : null;
          e.slides.forEach((slide) => {
            const video = slide.querySelector('yg-video');
            if (video && typeof video.pauseVideo === 'function') {
              video.pauseVideo();
            }
          })
        }
    }
    if (!window.customElements.get('YGVideoList02')) {
        window.customElements.define('yg-video-list-02',YGVideoList02)
    }
  })

  } catch(e) { console.error(e); }
})();
})();
